class Icons {
  constructor() {
    this._timeline = new TimelineMax({
      paused: true
    });
  }

  timeline() {
    this.strategy();
    this.speed();
    this.change();
    this.diversity();
    return this._timeline;
  }

  change() {
    const svg = document.getElementById('values-change');
    if ( ! svg ) return;

    const circle = svg.querySelector('.circle');
    const lines = svg.querySelectorAll('.line');

    let timeline = new TimelineMax();

    // Circle
    let to = {
      rotation: 180,
      ease: Back.easeIn.config(1.5),
      transformOrigin: "50% 50%",
    };

    timeline.add(TweenMax.to(circle, 1.2, to));

    // Line
    let lineObj = {
      length: 0,
      totalLength: lines[0].getTotalLength()
    };

    function drawLine() {
      for ( var i = 0; i < lines.length; i++ ) {
        lines[i].style.strokeDasharray = [lineObj.length, lineObj.totalLength].join(' ');
      }
    }

    drawLine();

    timeline.to(lineObj, .48, {length: lineObj.totalLength, onUpdate: drawLine, easing: Circ.easeIn}, .72);

    this._timeline.add(timeline);
  }

  speed() {
    const svg = document.getElementById('values-speed')
    if ( ! svg ) return;

    const timeline = new TimelineMax();

    timeline.to(svg.querySelector('.spinner'), 1.25, { ease: Power3.easeInOut, rotation: 360, svgOrigin: '96px 96px' })

    this._timeline.add(timeline)
  }

  strategy() {
    const svg = document.getElementById('values-strategy')
    if ( ! svg ) return;

    const timeline = new TimelineMax();

    timeline.from(svg.querySelector('.arrow'), 1, { ease: Expo.easeIn, x: 140, y: -140 })

    this._timeline.add(timeline)
  }

  diversity() {
    const svg = document.getElementById('values-unity');
    if ( ! svg ) return;

    const pieces = document.querySelectorAll('.piece');

    let timeline = new TimelineMax();

    timeline.add(TweenMax.to(pieces[0], 0.35, {x: -23, y: 15, scale: 1.05, transformOrigin: "50% 50%"}));
    timeline.add(TweenMax.to(pieces[0], .85, {rotation: -90, x: 45, y: -12, scale: 1, transformOrigin: "50% 50%"}));

    timeline.add(TweenMax.to(pieces[1], 0.35, {x: -15, y: -23, scale: 1.05, transformOrigin: "50% 50%"}), 0);
    timeline.add(TweenMax.to(pieces[1], .85, {rotation: -90, x: 12, y: 45, scale: 1, transformOrigin: "50% 50%"}), 0.35);

    timeline.add(TweenMax.to(pieces[2], 0.35, {x: 15, y: 23, scale: 1.05, transformOrigin: "50% 50%"}), 0);
    timeline.add(TweenMax.to(pieces[2], .85, {rotation: -90, x: -12, y: -45, scale: 1, transformOrigin: "50% 50%"}), 0.35);

    timeline.add(TweenMax.to(pieces[3], 0.35, {x: 23, y: -15, scale: 1.05, transformOrigin: "50% 50%"}), 0);
    timeline.add(TweenMax.to(pieces[3], .85, {rotation: -90, x: -45, y: 12, scale: 1, transformOrigin: "50% 50%"}), 0.35);

    this._timeline.add(timeline);
  }
}

export default Icons;



// WEBPACK FOOTER //
// ./scripts/components/icons.js